import {
  REMOVE_PERSONALIZED_SIZE,
  RESET_FACET_GROUP,
  ROLLBACK_FILTERS,
  TOGGLE_FACET_CHOSEN,
  TOGGLE_FACET_GROUP_SHOW_MORE,
  TOGGLE_PERSONALIZED_SIZE,
  TOGGLE_SELECTED_FACET,
  TOGGLE_SELECTED_FACET_GROUP,
  TOGGLE_SIZING_FACET_GROUP
} from 'constants/reduxActions';

export function resetFacetGroup(facetField, hydraSizingAssist, hydraPills, hydraNewSearchNav) {
  return {
    type: RESET_FACET_GROUP,
    facetField,
    hydraSizingAssist,
    hydraPills,
    hydraNewSearchNav
  };
}

export function toggleFacetChosen(groupName) {
  return {
    type: TOGGLE_FACET_CHOSEN,
    facets: {
      groupName
    }
  };
}

export function rollbackFilters(facetGroup) {
  return {
    type: ROLLBACK_FILTERS,
    facetGroup
  };
}

export function toggleSelectedFacetGroup(selectedFacetGroupName, hydraSizingAssist, hydraPills, hydraNewSearchNav, section) {
  return {
    type: TOGGLE_SELECTED_FACET_GROUP,
    selectedFacetGroupName,
    hydraSizingAssist,
    hydraPills,
    hydraNewSearchNav,
    section
  };
}

export function toggleSelectedFacet(facetGroup, facetName, selectedFacetGroupIndex, selectedFacetIndex, hydraSizingAssist, hydraPills, hydraNewSearchNav, section) {
  return {
    type: TOGGLE_SELECTED_FACET,
    facetGroup,
    facetName,
    selectedFacetIndex,
    selectedFacetGroupIndex,
    section,
    hydraSizingAssist,
    hydraPills,
    hydraNewSearchNav
  };
}

export function toggleSizingFacetGroup() {
  return {
    type: TOGGLE_SIZING_FACET_GROUP
  };
}

export function togglePersonalizedSize(response, hydraSizingAssist, hydraPills, hydraNewSearchNav) {
  return {
    type: TOGGLE_PERSONALIZED_SIZE,
    response,
    hydraSizingAssist,
    hydraPills,
    hydraNewSearchNav
  };
}

export function removePersonalizedSize() {
  return {
    type: REMOVE_PERSONALIZED_SIZE
  };
}

export function toggleFacetGroupShowMore(selectedFacetGroupName, selectedFacetIndex, section) {
  return {
    type: TOGGLE_FACET_GROUP_SHOW_MORE,
    selectedFacetGroupName,
    selectedFacetIndex,
    section
  };
}
